const calculateIMC = (weight, height) => {
  if (weight && height) {
    return (weight / (height * height)).toFixed(2)
  }
  return null
}

export default calculateIMC
